import { DecodeDracoUrlToBufferGeometry } from '@/engine/Utilities/DracoUtils';
import type { IInstrumentationModelsProvider } from './Interfaces';
import type * as THREE from 'three';

export class InstrumentationModelsProvider implements IInstrumentationModelsProvider {
  private _models: Map<string, THREE.BufferGeometry> = new Map();

  public async provideModelAsync(url: string): Promise<THREE.BufferGeometry> {
    const model = this._models.get(url);
    if (!model) {
      const newModel = await DecodeDracoUrlToBufferGeometry(import.meta.env.BASE_URL + url);
      this._models.set(url, newModel);
      return newModel;
    }
    return model;
  }
}
